export default __webpack_public_path__ + "static/media/flower.8ced52de.svg";